import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { getFirstItem as $eIXPM$getFirstItem, getChildNodes as $eIXPM$getChildNodes, getNthItem as $eIXPM$getNthItem } from "@react-stately/collections";
import { GridKeyboardDelegate as $eIXPM$GridKeyboardDelegate } from "@react-aria/grid";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $0ba3c81c7f1caedd$export$da43f8f5cb04028d = /*#__PURE__*/function (_ref) {
  _inherits($0ba3c81c7f1caedd$export$da43f8f5cb04028d, _ref);
  function $0ba3c81c7f1caedd$export$da43f8f5cb04028d() {
    _classCallCheck(this, $0ba3c81c7f1caedd$export$da43f8f5cb04028d);
    return _possibleConstructorReturn(this, _getPrototypeOf($0ba3c81c7f1caedd$export$da43f8f5cb04028d).apply(this, arguments));
  }
  _createClass($0ba3c81c7f1caedd$export$da43f8f5cb04028d, [{
    key: "isCell",
    value: function isCell(node) {
      return node.type === 'cell' || node.type === 'rowheader' || node.type === 'column';
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      var startItem = this.collection.getItem(key);
      if (!startItem) return null;
      // If focus was on a column, then focus the first child column if any,
      // or find the corresponding cell in the first row.
      if (startItem.type === 'column') {
        var _getNthItem;
        var child = (0, $eIXPM$getFirstItem)((0, $eIXPM$getChildNodes)(startItem, this.collection));
        if (child) return child.key;
        var firstKey = this.getFirstKey();
        if (firstKey == null) return null;
        var firstItem = this.collection.getItem(firstKey);
        if (!firstItem) return null;
        var _getNthItem_key;
        return (_getNthItem_key = (_getNthItem = (0, $eIXPM$getNthItem)((0, $eIXPM$getChildNodes)(firstItem, this.collection), startItem.index)) === null || _getNthItem === void 0 ? void 0 : _getNthItem.key) !== null && _getNthItem_key !== void 0 ? _getNthItem_key : null;
      }
      return _superPropGet($0ba3c81c7f1caedd$export$da43f8f5cb04028d, "getKeyBelow", this, 3)([key]);
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      var startItem = this.collection.getItem(key);
      if (!startItem) return null;
      // If focus was on a column, focus the parent column if any
      if (startItem.type === 'column') {
        var parent = startItem.parentKey != null ? this.collection.getItem(startItem.parentKey) : null;
        if (parent && parent.type === 'column') return parent.key;
        return null;
      }
      // only return above row key if not header row
      var superKey = _superPropGet($0ba3c81c7f1caedd$export$da43f8f5cb04028d, "getKeyAbove", this, 3)([key]);
      var superItem = superKey != null ? this.collection.getItem(superKey) : null;
      if (superItem && superItem.type !== 'headerrow') return superKey;
      // If no item was found, and focus was on a cell, then focus the
      // corresponding column header.
      if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
      // If focus was on a row, then focus the first column header.
      return this.collection.columns[0].key;
    }
  }, {
    key: "findNextColumnKey",
    value: function findNextColumnKey(column) {
      // Search following columns
      var key = this.findNextKey(column.key, function (item) {
        return item.type === 'column';
      });
      if (key != null) return key;
      // Wrap around to the first column
      var row = this.collection.headerRows[column.level];
      var _iterator = _createForOfIteratorHelper((0, $eIXPM$getChildNodes)(row, this.collection)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.type === 'column') return item.key;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "findPreviousColumnKey",
    value: function findPreviousColumnKey(column) {
      // Search previous columns
      var key = this.findPreviousKey(column.key, function (item) {
        return item.type === 'column';
      });
      if (key != null) return key;
      // Wrap around to the last column
      var row = this.collection.headerRows[column.level];
      var childNodes = _toConsumableArray((0, $eIXPM$getChildNodes)(row, this.collection));
      for (var i = childNodes.length - 1; i >= 0; i--) {
        var item = childNodes[i];
        if (item.type === 'column') return item.key;
      }
      return null;
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      var item = this.collection.getItem(key);
      if (!item) return null;
      // If focus was on a column, then focus the next column
      if (item.type === 'column') return this.direction === 'rtl' ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
      return _superPropGet($0ba3c81c7f1caedd$export$da43f8f5cb04028d, "getKeyRightOf", this, 3)([key]);
    }
  }, {
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      var item = this.collection.getItem(key);
      if (!item) return null;
      // If focus was on a column, then focus the previous column
      if (item.type === 'column') return this.direction === 'rtl' ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
      return _superPropGet($0ba3c81c7f1caedd$export$da43f8f5cb04028d, "getKeyLeftOf", this, 3)([key]);
    }
  }, {
    key: "getKeyForSearch",
    value: function getKeyForSearch(search, fromKey) {
      if (!this.collator) return null;
      var collection = this.collection;
      var key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
      if (key == null) return null;
      // If the starting key is a cell, search from its parent row.
      var startItem = collection.getItem(key);
      var _startItem_parentKey;
      if ((startItem === null || startItem === void 0 ? void 0 : startItem.type) === 'cell') key = (_startItem_parentKey = startItem.parentKey) !== null && _startItem_parentKey !== void 0 ? _startItem_parentKey : null;
      var hasWrapped = false;
      while (key != null) {
        var item = collection.getItem(key);
        if (!item) return null;
        // Check each of the row header cells in this row for a match
        var _iterator2 = _createForOfIteratorHelper((0, $eIXPM$getChildNodes)(item, this.collection)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var cell = _step2.value;
            var column = collection.columns[cell.index];
            if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
              var substring = cell.textValue.slice(0, search.length);
              if (this.collator.compare(substring, search) === 0) {
                // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                var fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                return (fromItem === null || fromItem === void 0 ? void 0 : fromItem.type) === 'cell' ? cell.key : item.key;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        key = this.getKeyBelow(key);
        // Wrap around when reaching the end of the collection
        if (key == null && !hasWrapped) {
          key = this.getFirstKey();
          hasWrapped = true;
        }
      }
      return null;
    }
  }]);
  return $0ba3c81c7f1caedd$export$da43f8f5cb04028d;
}((0, $eIXPM$GridKeyboardDelegate));
export { $0ba3c81c7f1caedd$export$da43f8f5cb04028d as TableKeyboardDelegate };